import { CheckCircle, CircleNotch, WarningCircle } from "@phosphor-icons/react";

// Oct 2026 - extracted from StockTransferPage.js so the GRN "Post to
// SAP" progress modal can use the EXACT same vertical step timeline
// (user's explicit ask: "IDENTICAL"), instead of drifting into its own
// slightly-different copy. Both pages import from here now.
export const STEP_ICON = {
  done: <CheckCircle size={18} weight="fill" className="text-[#12B76A]" />,
  active: <CircleNotch size={18} className="text-[#7A5AF8] animate-spin" />,
  failed: <WarningCircle size={18} weight="fill" className="text-[#F04438]" />,
  manual: <WarningCircle size={18} weight="fill" className="text-[#B54708]" />,
  paused: <span className="block w-[10px] h-[10px] rounded-full bg-[#98A2B3] mx-auto" />,
  pending: <span className="block w-[10px] h-[10px] rounded-full border-2 border-[#D0D5DD] mx-auto" />,
};
export const STEP_PILL = {
  done: "bg-[#ECFDF3] text-[#027A48]",
  active: "bg-[#F4F3FF] text-[#5925DC]",
  failed: "bg-[#FEF3F2] text-[#B42318]",
  manual: "bg-[#FFFAEB] text-[#B54708]",
  paused: "bg-[#F2F4F7] text-[#475467]",
  pending: "bg-[#F9FAFB] text-[#98A2B3]",
};
export const STEP_PILL_LABEL = { done: "Done", active: "In Progress", failed: "Failed", manual: "Action Needed", paused: "Paused", pending: "Pending" };

export const TimelineNode = ({ testId, label, state, isLast, children }) => (
  <div className="flex items-start gap-3" data-testid={testId} data-step-state={state}>
    <div className="flex flex-col items-center">
      <div className="w-[18px] h-[18px] flex items-center justify-center shrink-0">{STEP_ICON[state]}</div>
      {!isLast && <div className="w-px flex-1 bg-[#E4E7EC] my-1" style={{ minHeight: 14 }} />}
    </div>
    <div className={isLast ? "flex-1 min-w-0" : "flex-1 min-w-0 pb-4"}>
      <div className="flex items-center gap-2 flex-wrap">
        <p className="text-sm font-medium text-[#1D2939]">{label}</p>
        <span className={`text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full shrink-0 ${STEP_PILL[state]}`}>{STEP_PILL_LABEL[state]}</span>
      </div>
      {children}
    </div>
  </div>
);
